import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  text = 'ACCEDÉ AL KIT ORTOPEDISTA PRO',
  href,
  className = ''
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (!href) {
      e.preventDefault();
      document.getElementById('comprar')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const Component = href ? motion.a : motion.button;
  return <Component href={href} onClick={handleClick} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`flex items-center justify-center gap-3 bg-amber-500 hover:bg-amber-400 text-slate-950 font-extrabold py-4 px-8 rounded-full shadow-[0_0_30px_rgba(245,158,11,0.3)] hover:shadow-[0_0_40px_rgba(245,158,11,0.5)] transition-all duration-300 text-lg md:text-xl w-full max-w-xl mx-auto uppercase tracking-wide border-b-4 border-amber-700 active:border-b-0 active:translate-y-1 ${className}`} data-id="element-31">
      <ShoppingCart className="w-6 h-6" data-id="element-32" />
      <span className="text-center" data-id="element-33">{text}</span>
    </Component>;
}